/* src/components/tis-create-update-category-modal/tis-create-update-category-modal.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=tis-create-update-category-modal.component-2KK3SGUH.css.map */
